import { isActive, persistQuery } from './service';
import NotificationProvider from '../common/NotificationProvider';
import hideForContainerApp from './hoc/hideForContainerApp';
import withIsPaddingActive from './hoc/withIsPaddingActive';
import BottomPadding from './components/BottomPadding';

export default (history) => ({
  NotificationProvider,
  isActive: () => isActive(history),
  hideForContainerApp: hideForContainerApp(history),
  persistQuery,
  BottomPadding: withIsPaddingActive(history)(BottomPadding),
});
